import React, { useEffect, useState } from 'react'
import styles from './exInventEnquiryForm.module.css'
import { Back, Close } from '../../../Svg'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deletexcessPreviewData, sendexcessEnquiryThunk, setSelectedProducts } from '../../redux/excessSlice';

const ExInventEnquiryForm = () => {
    const location = useLocation();


    // const data = location.state
    const [data, setData] = useState(location.state)


    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)


    const getBreakQtyDetails = (quantityTable, quantity) => {
        if (!Array.isArray(quantityTable) || quantityTable.length === 0) {
            return { breakQty: 1, unitPrice: 0 };
        }
        const sortedTable = [...quantityTable]?.sort((a, b) => (a?.breakQty || 0) - (b?.breakQty || 0));
        return sortedTable.find((entry) => quantity <= entry?.breakQty) || sortedTable[sortedTable.length - 1] || { breakQty: 1, unitPrice: 0 };
    };

    const calculateTotal = () => {
        return data?.reduce((total, product) => {

            const priceDetails = getBreakQtyDetails(product.quantityTable, product.quantity);

            const unitPrice = priceDetails ? priceDetails.unitPrice : 0;

            return total + product.quantity * unitPrice;
        }, 0);
    };




    useEffect(() => {
        setData(location.state)
    }, [location])

    const formik = useFormik({
        initialValues: {
            partList: data?.map(item => {
                const { unitPrice } = getBreakQtyDetails(item?.product?.quantityTable, item?.quantity)

                return ({
                    productNumber: item.productNumber || '',
                    manufacturer: item.manufacturer || '',
                    quantity: item.quantity || '',
                    targetPrice: item.targetPrice || '',
                    requiredDate: item.requiredDate || '',
                    masterPrice: (unitPrice * item?.quantity) || 0
                })
            }
            )
        },
        validationSchema: Yup.object({
            partList: Yup.array().of(
                Yup.object().shape({
                    quantity: Yup.number().required('Required'),
                    targetPrice: Yup.number(),
                    requiredDate: Yup.string()
                })
            )
        }),
        onSubmit: async values => {
            setLoading(true)
            const status = await dispatch(sendexcessEnquiryThunk(values))
            if (status.payload == 200) {
                dispatch(deletexcessPreviewData())
                // Back to the Excess Inventory main page with nothing left selected
                dispatch(setSelectedProducts([]))
                navigate('/exInventoryBuyItem')
            }
            setLoading(false)
        }
    });

    console.log(formik.values);

    const handleDelete = (productNumber) => {
        const filter = data?.filter(i => i?.productNumber != productNumber)
        setData(filter)
    }

    return (
        <>
            <div className={styles.imgBread}>
                <span>Excess Inventory</span>
            </div>
            <div className={styles.exInContainer}>
                <div>
                    <button className={styles.compBtn} onClick={() => navigate(-1)}><Back />Back to previous page</button>
                </div>

                <div className={styles.exInForm}>
                    <p>Please fill out the quote request form below and a Electrowiz representative will contact you shortly. </p>
                    <span className={styles.previewTitle}>Part list</span>
                    <div className={styles.hrLine}></div>


                    <form onSubmit={formik.handleSubmit}>
                        <>
                            <div className={styles.productTableContainerscroll}>
                                <table className={styles.previewtable}>
                                    <thead>
                                        <tr>
                                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
                                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Manufacture Part #</th>
                                            <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Quantity</th>
                                            <th className={styles.previewth}>Manufacture/purchase order #</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((item, index) => (
                                            <React.Fragment key={item.id}>
                                                <tr key={item.id} className={styles.previewstripedRow}>
                                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{index + 1}</td>
                                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item?.productNumber}</td>
                                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{formik.values.partList[index].quantity}</td>
                                                    <td className={styles.previewtd}>
                                                        <div className={styles.closetd} onClick={() => handleDelete(item?.productNumber)} style={{ cursor: 'pointer' }}>
                                                            {item.manufacturer} <Close />
                                                        </div>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td colSpan="4">
                                                        <div className={styles.qrForm}>
                                                            <span className={styles.previewTitle}>Enquiry Form</span>
                                                            <div className={styles.qrForminputMain}>
                                                                <div className={styles.qrForminputs}>
                                                                    <div className={styles.loginInputGroup}>
                                                                        <label>
                                                                            <div>
                                                                                Required Quantity*
                                                                            </div>
                                                                            <input
                                                                                type="text"
                                                                                name={`partList[${index}].quantity`}
                                                                                value={formik.values.partList[index].quantity}
                                                                                onChange={(e) => {
                                                                                    formik.handleChange(e);
                                                                                    const newQuantity = Number(e.target.value) || 0;
                                                                                    const unitPrice = getBreakQtyDetails(data[index]?.product?.quantityTable, newQuantity)?.unitPrice || 0;
                                                                                    formik.setFieldValue(`partList[${index}].masterPrice`, unitPrice * newQuantity);
                                                                                }}
                                                                                onBlur={formik.handleBlur}
                                                                                placeholder="Enter quantity"
                                                                            />

                                                                            {formik.touched.partList?.[index]?.quantity && formik.errors.partList?.[index]?.quantity && (
                                                                                <div className={styles.error}>{formik.errors.partList[index].quantity}</div>
                                                                            )}
                                                                        </label>
                                                                    </div>
                                                                    <div className={styles.loginInputGroup}>
                                                                        <label>
                                                                            <div>Target Price</div>
                                                                            <input
                                                                                type="text"
                                                                                name={`partList[${index}].targetPrice`}
                                                                                value={formik.values.partList[index].targetPrice}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                placeholder="Enter expected price"
                                                                            />
                                                                            {formik.touched.partList?.[index]?.targetPrice && formik.errors.partList?.[index]?.targetPrice && (
                                                                                <div className={styles.error}>{formik.errors.partList[index].targetPrice}</div>
                                                                            )}
                                                                        </label>
                                                                    </div>
                                                                    <div className={styles.loginInputGroup}>
                                                                        <label>
                                                                            <div>Required Date</div>
                                                                            <input
                                                                                type="date"
                                                                                name={`partList[${index}].requiredDate`}
                                                                                value={formik.values.partList[index].requiredDate}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                placeholder="Enter required date"
                                                                            />
                                                                            {formik.touched.partList?.[index]?.requiredDate && formik.errors.partList?.[index]?.requiredDate && (
                                                                                <div className={styles.error}>{formik.errors.partList[index].requiredDate}</div>
                                                                            )}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={styles.hrLine}></div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className={styles.displayFlex}>
                                <button type="button" className={styles.cancelBtn} onClick={() => navigate(-1)}>Back</button>
                                <button type="submit" className={styles.submitBtn} disabled={loading}>{loading ? "please wait" : "Submit"}</button>
                            </div>
                        </>
                    </form>



                </div>
            </div>
        </>
    )
}

export default ExInventEnquiryForm